import { IconCheck, IconX } from "@tabler/icons-react";
import styles from "./profileCompletionCard.module.css";
import { Link } from "react-router-dom";

const ProfileCompletionCard = ({ profileData = {}, showLink = false }) => {
  const socialLinks = {
    facebookUrl: profileData?.facebookUrl,
    twitterUrl: profileData?.twitterUrl,
    instagramUrl: profileData?.instagramUrl,
    linkedinUrl: profileData?.linkedinUrl,
    youtubeUrl: profileData?.youtubeUrl,
  };

  const hasValue = (value) =>
    typeof value === "string" ? value.trim().length > 0 : Boolean(value);

  const checkGeneralInfo =
    hasValue(profileData?.companyName) && hasValue(profileData?.companyAddress);

  const checkClassification =
    (Array.isArray(profileData?.industry) && profileData?.industry?.length > 0) ||
    hasValue(profileData?.companySize);

  const checkLogo = hasValue(profileData?.clientLogo);

  const checkSocial = Object?.values(socialLinks)?.some(hasValue);

  const checkAbout = !!profileData?.summary?.trim();

  const CHECKLIST = [
    { id: "general", label: "General information", done: checkGeneralInfo },
    {
      id: "category",
      label: "Industry & company size",
      done: checkClassification,
    },
    { id: "logo", label: "Company logo", done: checkLogo },
    { id: "social", label: "Social links", done: checkSocial },
    { id: "about", label: "About company", done: checkAbout },
  ];

  const completedCount = CHECKLIST?.filter((c) => c.done)?.length;
  const pct = Math.round((completedCount / CHECKLIST?.length) * 100) || 0;

  return (
    <div className={styles.card} id="profileCompletionCard">
      <div className={styles.header}>
        <span className={styles.title}>Profile Completeness</span>
        <span className={styles.pct}>{pct}%</span>
      </div>

      <div className={styles.progressBar}>
        <div className={styles.progressFill} style={{ width: `${pct}%` }} />
      </div>

      <p className={styles.hint}>Complete your profile to attract top talent</p>

      <div className={styles.checklist}>
        {CHECKLIST?.map(({ id, label, done }) => (
          <div key={id} className={styles.checklistItem}>
            <div
              className={`${styles.checkIcon} ${done ? styles.checkIconDone : styles.checkIconTodo}`}
            >
              {done ? <IconCheck size={11} /> : <IconX size={11} />}
            </div>
            {label}
          </div>
        ))}
      </div>
      {showLink && (
        <Link
          to="/company-profile"
          className={`${styles.completionCta} ${pct == 100 ? styles.completionCtaDone : ""}`}
        >
          {pct == 100 ? "View Profile" : "Complete Profile"}
        </Link>
      )}
    </div>
  );
};

export default ProfileCompletionCard;
